const handleDeleteUserFormParamUser = {
  confirm: 'Deseja realmente deletar esse colaborador?',
  title: 'DELETAR COLABORADOR'
};

export default handleDeleteUserFormParamUser;
